import { CallStatus } from './call-status.enum';
import type { CallSession } from './call-session.model';
import type { DeviceState } from './device-state.model';

/** Root state for the telephony module */
export interface TelephonyState {
  /** Current call status */
  callStatus: CallStatus;
  /** Active call session (null when idle) */
  currentSession: CallSession | null;
  /** Audio device state */
  deviceState: DeviceState;
  /** Last error message */
  lastError: string | null;
  /** Number of reconnection attempts */
  reconnectAttempts: number;
}

/** Initial/default telephony state */
export const INITIAL_TELEPHONY_STATE: TelephonyState = {
  callStatus: CallStatus.Idle,
  currentSession: null,
  deviceState: {
    audioInputs: [],
    audioOutputs: [],
    selectedAudioInputId: null,
    selectedAudioOutputId: null,
  },
  lastError: null,
  reconnectAttempts: 0,
};
